import $ from 'jquery';
import moment from 'moment/moment';
import 'moment/locale/pl';

export const elements = {
    time: 'time[friendly-date]'
};

export const sourceFormat = 'YYYYMMDDTHH:mm';
export const interval = (1000 * 60); 

export const transform = (params) => {
    params.$document.find(elements.time).each((key, element) => {
        const $element = $(element);
        const datetime = $element.attr('datetime');
        const niceDate = moment(datetime, sourceFormat).fromNow();

        $element.html(niceDate);
    });
};

export default {
    init(params) {
        /* Set currentl locale for relative date translation */
        /* @todo: should go from config or be detected on frontend? */
        moment.locale('pl');

        /* run on initial */
        transform(params);

        /**
         * @todo: should come from config - are we doing central config?
         */
        setInterval($.proxy(transform, null, params), interval);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/friendly-date.js